module.exports = __webpack_public_path__ + "img/ngpvan.5c3ba57e.png";